import type { BackendTypes } from '@tf/api';
import { T } from '@tf/utils';

import type { Application } from '@/core/api';

export const getReviewConnections = (
	application: Application,
	applicationConnectionKind: BackendTypes.EntityConnectionKind,
) => {
	// applicationConnectionKind can belong to review connection or some additional connection from review group
	//	In the second case we need to find main review connection
	const connection = application.account.listConnections.find((c) => c.connectionKind === applicationConnectionKind);
	T.assertNotNullish(connection, `connection not found in application connections: ${applicationConnectionKind}`);

	const reviewConnectionKind = connection.isReview
		? connection.connectionKind
		: application.account.listConnections.find((c) => c.isReview && c.reviewGroup === connection.reviewGroup)
				?.connectionKind;

	return application.reviews.filter((r) => r.connectionKind === reviewConnectionKind);
};
